module.exports = __webpack_public_path__ + "img/register-footer.fd79a24d.png";